module.exports = __webpack_public_path__ + "static/media/logo.dbc92fe8.png";